export default {
    data() {
        return {
            status: false,
            Items: null,
            fullData: null,
            disabled: false,
        };
    },
    methods: {
        changePage(page) {
            this.$router.replace({
                path: this.$route.path,
                query: {...this.$route.query, page: page }
            });
        },
        getItemsFromServer(url, page, all = false, query = "", key = null, params = "") {
            this.status = true;
            this.$axios
                .get(url + params + (all == true ? "?all=1" + query : "?page=" + page + query))
                .then((response) => {
                    this.status = false;
                    if (key != null) {
                        this.Items =
                            all == true ?
                            response.data.data[key] :
                            response.data.data[key].data;
                        this.fullData = all == true ? null : response.data.data[key];
                    } else {
                        this.Items = all == true ? response.data : response.data.data.data;
                    }
                    if (response.data.data.widgets) {
                        this.widgets = response.data.data.widgets
                    }
                })
                .catch((error) => {
                    this.status = false;
                    this.$root.notify(error);
                });
        },
        deleteItem(id) {
            window
                .swal({
                    title: "آیتم حذف شود؟",
                    text: "این عمل بازگشت پذیر نیست",
                    icon: "warning",

                    showCancelButton: true,
                    showConfirmButton: true,
                    dangerMode: true,
                    buttons: ["خیر", "بله"]
                })
                .then((willDelete) => {
                    if (willDelete) {
                        this.$axios
                            .delete(this.current_url + `/${id}`)
                            .then((response) => {
                                window.swal({
                                    icon: "success",
                                    showConfirmButton: true,
                                    text: response.data.message,
                                    button: "OK"
                                });
                                this.Items = this.Items.filter((item) => item.id != id);
                            })
                            .catch((error) => {
                                window.swal({
                                    title: "خطا",
                                    showConfirmButton: true,
                                    text: error.response.data.message,
                                    button: "OK"
                                });
                            });
                    }
                })
                .catch(() => {});
        },
        showEditModal(item) {

            this.edit_item = item;
            this.editItem = item;

            this.mode = "edit";
            this.showpModal = true;
        },
        async submit(form_data) {
            form_data.append("_method", this.mode == "edit" ? "put" : "post");

            this.disabled = true;
            await this.$axios
                .post(
                    this.current_url +
                    (this.mode == "edit" ? `/${this.edit_item.id}` : ""),
                    form_data
                )
                .then((response) => {
                    this.disabled = false;
                    this.getItemsFromServer(
                        this.current_url,
                        1,
                        false,
                        "",
                        this.routeKey, this.urlParams != undefined ? this.urlParams : ""
                    );
                    this.mode = "create";
                    this.$root.notify(response.data.message, "success");
                    this.showpModal = false;
                    this.edit_item = null;
                })
                .catch((error) => {
                    this.disabled = false;
                    this.$root.notify(error);
                });
        },
        // call in modal component
        resetModal() {
            this.$emit("changeDisplayModal", false);
            this.headers.forEach((header) => {
                if (header.type == "boolean") {
                    if (this.booleans[header.key] != undefined) {
                        this.booleans[header.key] = false;
                    }
                } else if (header.type == "image") {
                    if (this.files[header.key] != undefined) {
                        this.files[header.key] = null;
                    }
                } else if (header.type == "select") {
                    if (header.multiple == false) {
                        this.selected[header.key] = null;
                    } else {
                        this.selected[header.key] = [];
                    }
                } else if (header.type == "list") {
                    this.listValue[header.key] = null;
                } else if (header.type == "specifications") {
                    this.selectedSpecificationList = [];
                    this.specification = null;
                    this.selectedSpecification = {};
                } else if (header.type == "ckEditor") {
                    this.editorData = null;
                } else if (header.type == "string") {
                    if (this.string[header.key] != undefined) {
                        this.string[header.key] = "";
                    }
                } else if (header.type == "description") {
                    if (this.description[header.key] != undefined) {
                        this.description[header.key] = "";
                    }
                }
            });
            this.editItem = null;

        }
    },
    watch: {
        "$route.query.page": {
            handler: function(val) {
                if (this.current_url != undefined) {
                    this.getItemsFromServer(
                        this.current_url,
                        val,
                        false,
                        "",
                        this.routeKey
                    );
                }
            }
        }
    }
};